import { library, dom } from '@fortawesome/fontawesome-svg-core'

import {faEnvelope} from '@fortawesome/free-solid-svg-icons/faEnvelope'
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons/faAngleLeft'
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight'
import {faPaperPlane} from '@fortawesome/free-solid-svg-icons/faPaperPlane'
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {faEllipsisH} from '@fortawesome/free-solid-svg-icons/faEllipsisH'
import {faReply} from '@fortawesome/free-solid-svg-icons/faReply'
import {faFilePdf} from '@fortawesome/free-solid-svg-icons/faFilePdf'
import {faFileImage} from '@fortawesome/free-solid-svg-icons/faFileImage'
import {faDotCircle} from '@fortawesome/free-solid-svg-icons/faDotCircle'
import {faCog} from '@fortawesome/free-solid-svg-icons/faCog'
import {faEnvelopeOpen} from '@fortawesome/free-solid-svg-icons/faEnvelopeOpen'
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit'


library.add(
    faEnvelope, faAngleLeft, faAngleRight, faPaperPlane, faPlus, faEllipsisH, faReply, faFilePdf, faFileImage,
    faDotCircle, faCog, faEnvelopeOpen, faEdit
)

dom.watch()